import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ClubTeamsService } from '../../../services/club-teams.service';
import { AppState, AppFields, AppTypes } from '../../../store';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-myprofile-left-nav',
  templateUrl: './myprofile-left-nav.component.html',
  styleUrls: ['./myprofile-left-nav.component.css']
})
export class MyprofileLeftNavComponent implements OnInit {
  isStaffEvaluations;
  showManu = true;
  links = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>,
    public service: ClubTeamsService
  ) {
    this.store.select(AppFields.App, AppFields.EvalautionAccount).subscribe(rs => {
      this.isStaffEvaluations = rs;
      if (this.isStaffEvaluations) {
        this.showManu = false;
      }
    });

    this.links = [
      { path: 'dashboard', title: 'Dashboard', show: this.showManu },
      { path: 'basic-info', title: 'Basic Info', show: true },
      { path: 'family-info', title: 'Family Info', show: true },
      { path: 'programs', title: 'Programs', show: true },
      { path: 'documents', title: 'Documents', show: true },
      { path: 'evaluation-info', title: 'Evaluations', show: this.showManu },
      { path: 'attendance', title: 'Attendance', show: true },
      { path: 'statistics', title: 'Statistics', show: true },
      { path: 'player-cards', title: 'Player Cards', show: this.showManu },
      // { path: 'infractions', title: 'Infractions', show: this.showManu },
      // { path: 'colege-profile ', title: 'College Profile', show: this.showManu }
    ];
  }

  ngOnInit() { }

  get playerID(): number {
    return this.route.snapshot.params.playerID;
  }

  get baseLink(): string {
    const splits = this.router.url.split('/');
    return splits.slice(0, splits.length - 1).join('/');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/myprofile-left-nav/myprofile-left-nav.component.ts